module.exports = __webpack_public_path__ + "img/app_icon_51.290fa696.png";